import { LanguageType } from 'types/index';

/**
 * Normalizes an arbitrary language code string to a supported `LanguageType`.
 *
 * The backend historically stored Norwegian as `"NO"` while this app only ships
 * translations under `public/locales/nb/`, keyed by `LanguageType.Norwegian`
 * (`"NB"`). The shell app also uses the BCP-47 codes `"no"` / `"nb"` / `"nn"`.
 * This helper collapses all of those to `LanguageType.Norwegian` so the i18n
 * pipeline always resolves to an existing translation file.
 */
export function normalizeLanguageType(value: string | null | undefined): LanguageType {
	if (!value) return LanguageType.English;

	const upper = value.toUpperCase();

	if (upper === 'NO' || upper === 'NB' || upper === 'NN') {
		return LanguageType.Norwegian;
	}

	if (upper === 'EN') return LanguageType.English;

	return LanguageType.English;
}
